export default [
	['basic', [
		{
			"question": "have longer teasing and foreplay sessions with partner",
			"answer": null,
			"advanced": false
		},
		{
			"question": "give {{P}} a sensual massage",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have {{P}} give me a sensual massage",
			"answer": null,
			"advanced": false
		},
		{
			"question": "take pictures of {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have pictures taken of me by {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "take pictures of us having sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "strip or give a lap dance to {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have {{P}} strip or give me a lap dance",
			"answer": null,
			"advanced": false
		},
		{
			"question": "video ourselves having sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "use mirrors while having sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be woken up with sex or oral sex by {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "wake up {{P}} with sex or oral sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "watch {{P}} masturbate",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be watched by {{P}} while I masturbate",
			"answer": null,
			"advanced": false
		},
		{
			"question": "shave {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be shaven by {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "shave each other",
			"answer": null,
			"advanced": false
		},
		{
			"question": "watch porn together",
			"answer": null,
			"advanced": false
		},
		{
			"question": "boobjob (thrust penis between breasts)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be more vocal towards {{P}} during sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have {{P}} be more vocal",
			"answer": null,
			"advanced": false
		},
		{
			"question": "talk dirtier to {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have {{P}} talk dirtier to me",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have sex while on period",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have sex while on period",
			"answer": null,
			"advanced": false
		},
		{
			"question": "roleplay in costumes",
			"answer": null,
			"advanced": false
		},
		{
			"question": "wear stocking and high heels for {{P}} during sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "listen to romantic music while having sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "listen to more aggressive (rap/rock) music while having sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "mutually masturbate",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be rougher in sex towards {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have {{P}} be rougher to me in sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be fisted by partner",
			"answer": null,
			"advanced": false
		},
		{
			"question": "69 together",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have {{P}} swallow my cum",
			"answer": null,
			"advanced": false
		},
		{
			"question": "swallow {{P}}'s cum",
			"answer": null,
			"advanced": false
		},
		{
			"question": "cum on breasts/neck (pearl necklace)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "cum on face (facial)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "cum on {{P}}'s face (facial)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have {{P}} cum over my face (facial)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have {{P}} sit on my face as I give oral sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "sit on {{P}}'s face and be given oral sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have sex in hot room and have drippy, sweaty sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have sex while covered in warm oil",
			"answer": null,
			"advanced": false
		},
		{
			"question": "give oral sex while {{P}} is driving",
			"answer": null,
			"advanced": false
		},
		{
			"question": "receive oral sex while driving",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have partner wear stockings and high heels during sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "fist {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "aggressively fuck partners mouth",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have mouth aggressively fucked by partner",
			"answer": null,
			"advanced": false
		},
		{
			"question": "send {{P}} sexy text messages and emails",
			"answer": null,
			"advanced": false
		},
		{
			"question": "receive sexy text messages and emails from {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "send {{P}} dirty pictures or videos",
			"answer": null,
			"advanced": false
		},
		{
			"question": "receive sexy pictures or videos from {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "send {{P}} sexy fantasy stories",
			"answer": null,
			"advanced": false
		},
		{
			"question": "receive sexy fantasy stories from {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have sex while intoxicated",
			"answer": null,
			"advanced": false
		}
	]],
	['discovery', [
		{
			"question": "show {{P}} something I like from a porn scene",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be shown what {{P}} likes from porn",
			"answer": null,
			"advanced": false
		},
		{
			"question": "Explore {{P}}'s body",
			"answer": null,
			"advanced": false
		},
		{
			"question": "Have {{P}} explore my body",
			"answer": null,
			"advanced": false
		},
		{
			"question": "Show {{P}} the spots and techniques I like on my body",
			"answer": null,
			"advanced": false
		},
		{
			"question": "Have {{P}} show me the spots and techniques they like on their body",
			"answer": null,
			"advanced": false
		}
	]],
	['toys', [
		{
			"question": "use dildos in sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "use vibrators while having sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "wear a cock ring (vibrating/non-vibrating) during sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "use nipple clamps on myself",
			"answer": null,
			"advanced": false
		},
		{
			"question": "use butt plug on myself while having sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have {{P}} use a butt plug",
			"answer": null,
			"advanced": false
		},
		{
			"question": "use sex furniture (such as a sex swing or ramp)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "watch {{P}} fuck a dildo",
			"answer": null,
			"advanced": false
		},
		{
			"question": "fuck dildo while {{P}} watches",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have {{P}} use nipple clamps",
			"answer": null,
			"advanced": false
		}
	]],
	['anal', [
		{
			"question": "anally finger {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be fingered anally by {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "anally penetrate {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "double penetrate partner with me and a toy",
			"answer": null,
			"advanced": false
		},
		{
			"question": "peg partner with a strap-on",
			"answer": null,
			"advanced": false
		},
		{
			"question": "lick {{P}}'s anus (analingus)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be licked anally by {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be anally penetrated by {{P}}",
			"answer": null,
			"advanced": false
		}
	]],
	['public', [
		{
			"question": "fondle {{P}} in a public setting (restaurant/theater)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be fondled by {{P}} in a public setting (restaurant/theater)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have my pictures posted on the internet",
			"answer": null,
			"advanced": false
		},
		{
			"question": "show pictures of us having sex over the internet",
			"answer": null,
			"advanced": false
		},
		{
			"question": "show pictures/film of {{P}} over the internet",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have sex in a car",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have sex in the woods or in a park",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have sex in work environment (office, etc)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have sex in front of an outward facing window",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have sex in a place where you might get caught",
			"answer": null,
			"advanced": false
		},
		{
			"question": "watch {{P}} have sex with another person",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have sex with another person while {{P}} watches",
			"answer": null,
			"advanced": false
		},
		{
			"question": "go to a strip club with partner",
			"answer": null,
			"advanced": false
		},
		{
			"question": "go to a sex or swingers club with partner",
			"answer": null,
			"advanced": false
		},
		{
			"question": "go to a nudist resort with partner",
			"answer": null,
			"advanced": false
		},
		{
			"question": "go to a pleasure resort with partner",
			"answer": null,
			"advanced": false
		},
		{
			"question": "start a social media account (i.e. instagram, tumblr, reddit) and post sexy videos and pictures",
			"answer": null,
			"advanced": false
		},
		{
			"question": "wear a vibrator with wireless remote that {{P}} controls in public",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have partner wear a vibrator with a wireless remote that you control in public",
			"answer": null,
			"advanced": false
		},
		{
			"question": "take sexy photos in secluded places (i.e. dirt road, park, parking garage)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "give lap dance to {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "get lap dance from {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "go commando in public",
			"answer": null,
			"advanced": false
		},
	]],
	['group', [
		{
			"question": "watch other couples have sex (live)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "let another couple watch us have sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "have another person take video/photos while we have sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "let a group of people watch us have sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "let a female friend watch us have sex",
			"answer": null,
			"advanced": false
		},
		{
			"question": "let a male friend watch us have sex",
			"answer": null,
			"advanced": false
		},
	]],
	['other', [
		{
			"question": "call {{P}} obscene words (bitch, slut, whore, etc)",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be called obscene words (bitch, slut, whore, etc) by {{P}}",
			"answer": null,
			"advanced": false
		},
		{
			"question": "give {{P}} a foot job",
			"answer": null,
			"advanced": false
		},
		{
			"question": "be given a foot job",
			"answer": null,
			"advanced": false
		},
		{
			"question": "douse ourselves in oil/mud/paint/milk/pies during sex",
			"answer": null,
			"advanced": false
		},
	]]
];


// WEBPACK FOOTER //
// ./src/lib/basicQuestions.ts